export const TICKET_SERVICE_CHARGE_PERCENTAGE = 14;
export const PASSAR_PLATFORM_FEE_PERCENTAGE = 4;
export const ORGANIZER_OPERATIONAL_CREDIT_PERCENTAGE = 10;

const LEGACY_SERVICE_CHARGE_PERCENTAGE = 15;
const ORGANIZER_TICKET_TYPES = new Set(['venue', 'producer', 'events', 'creator']);

const roundCurrency = (value) => Math.round((Number(value) || 0) * 100) / 100;

export const usesOrganizerTicketPricing = (organizationType) => (
  ORGANIZER_TICKET_TYPES.has(organizationType)
);

export const getPublicEventTicketPricing = ({ basePrice, quantity = 1, organizationType, payer = 'customer' }) => {
  const normalizedBasePrice = roundCurrency(basePrice);
  const normalizedQuantity = Math.max(1, Number.parseInt(quantity, 10) || 1);
  const appliesOrganizerPricing = usesOrganizerTicketPricing(organizationType);
  const serviceChargePercentage = appliesOrganizerPricing
    ? TICKET_SERVICE_CHARGE_PERCENTAGE
    : LEGACY_SERVICE_CHARGE_PERCENTAGE;
  const customerPaysServiceCharge = payer !== 'salon';
  const baseAmount = roundCurrency(normalizedBasePrice * normalizedQuantity);
  const unitPrice = customerPaysServiceCharge
    ? roundCurrency(normalizedBasePrice * (1 + serviceChargePercentage / 100))
    : normalizedBasePrice;

  return {
    unitPrice,
    totalAmount: roundCurrency(unitPrice * normalizedQuantity),
    serviceChargeAmount: customerPaysServiceCharge
      ? roundCurrency(baseAmount * (serviceChargePercentage / 100))
      : 0,
    customerPaysServiceCharge
  };
};
